import * as _ from 'lodash';

import Salary from './Salary.js';
import ClassDate from './DateFunction';

export const VALIDATORS = {
  salary: Salary,
  date: ClassDate,
}

const VALIDATORS_INVERTED = _.invert(VALIDATORS);

export default class ValidationRules {
  constructor(validators = []) {
    if (validators.length === 0) {
      Object.keys(VALIDATORS).forEach(key => {
        this[key] = new VALIDATORS[key]()
      });
    } else {
      validators.forEach(validator => {
        const key = VALIDATORS_INVERTED[validator];
        this[key] = new validator();
      });
    }
  }
}
